import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { LogTagAnexoService } from 'src/app/services/log-tag-anexo.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-tag-historico-modal',
  templateUrl: './tag-historico-modal.component.html',
  styleUrls: ['./tag-historico-modal.component.scss']
})
export class TagHistoricoModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};
  idCupom;
  logs: any[] = [];

  constructor(public dialogRef: MatDialogRef<TagHistoricoModalComponent>, private logTagAnexoService: LogTagAnexoService, private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService, private utilitarioService: UtilitarioService,
    private globalService: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any) {

    this.idCupom = data.idCupom;

  }

  ngOnInit(): void {
    this.buscarLogs();
  }

  voltar() {
    this.dialogRef.close();
  }

  buscarLogs() {
    this.carregandoService.mostra('buscarLogs');
    this.logTagAnexoService.consultarLogDeTagsDoPedido(this.idCupom).subscribe(
      (retorno) => {

        this.logs = retorno;
        this.carregandoService.esconde('buscarLogs');
      },
      (erro) => {
        this.carregandoService.esconde('buscarLogs');
        this.notificacaoService.erro(erro);
      }
    );
  }

}
